import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

export const FCRADisclaimer = ({ className = '' }: { className?: string }) => {
  return (
    <div className={`bg-[#FFF7ED] border border-[#FFA94D] rounded-lg p-4 ${className}`}>
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-[#FF8C00] flex-shrink-0 mt-0.5" />
        <div className="text-sm text-[#8B4513] leading-relaxed">
          <p className="font-semibold text-[#8B4513] mb-2">FCRA Disclaimer</p>
          <p>
            CollectABILITY is dedicated to helping you find people and learn more about them in a safe and responsible manner. <span className="font-semibold">CollectABILITY is not a Consumer Reporting Agency (CRA) as defined by the Fair Credit Reporting Act (FCRA).</span> This site cannot be used for employment, credit or tenant screening, or any related purpose. For more information, visit our{' '}
            <Link to="/terms" className="text-[#FF8C00] underline hover:text-[#CC6F00]">
              Terms of Service
            </Link>
            {' '}and{' '}
            <Link to="/privacy" className="text-[#FF8C00] underline hover:text-[#CC6F00]">
              Privacy Policy
            </Link>.
          </p>
        </div>
      </div>
    </div>
  );
};

export const FCRAFooterText = () => {
  return (
    <div className="text-slate-600 text-[9px] leading-relaxed max-w-4xl mx-auto text-center">
      <p>
        CollectABILITY provides data verification, enrichment, and scoring services for permissible business use cases. <span className="font-semibold text-slate-900">CollectABILITY is not a Consumer Reporting Agency (CRA) as defined by the Fair Credit Reporting Act (FCRA).</span> This site cannot be used for employment, credit or tenant screening, or any related purpose. To learn more, visit our{' '}
        <Link to="/terms" className="text-slate-600 hover:text-slate-900 underline">
          Terms of Service
        </Link>
        {' '}and{' '}
        <Link to="/privacy" className="text-slate-600 hover:text-slate-900 underline">
          Privacy Policy
        </Link>.
      </p>
    </div>
  );
};
